import { CheckoutStatus } from "@/types";
import { type ExternalVerificationConfig } from "./types";

export const QUESTIONNAIRE_VERIFICATION_CONFIG: ExternalVerificationConfig = {
  localeKey: "questionnaire",
  redirectPath: "/questionnaire",
  returnPath: "/questionnaire/return",
  loadingStatuses: [CheckoutStatus.CHECKING_QUESTIONNAIRE_REQUIRED],
  awaitStatus: CheckoutStatus.AWAIT_QUESTIONNAIRE_COMPLETION,
  verifyEndpoint: "verify-questionnaire",
  storageKey: "questionnaire_redirect_initiated",
  sessionStorageKeyPrefix: "cosmos_questionnaire_redirect",
  logTag: "questionnaire",
  telemetry: {
    redirectToUi: "QUESTIONNAIRE_REDIRECT_TO_UI",
    returnFromUi: "QUESTIONNAIRE_RETURN_FROM_UI",
    verifySuccess: "QUESTIONNAIRE_VERIFY_SUCCESS",
    verifyFailed: "QUESTIONNAIRE_VERIFY_FAILED",
  },
  redirectIcon: "clipboard",
};

export const IDV_VERIFICATION_CONFIG: ExternalVerificationConfig = {
  localeKey: "kyc",
  redirectPath: "/kyc",
  returnPath: "/kyc/return",
  loadingStatuses: [
    CheckoutStatus.CHECKING_IDV_ELIGIBILITY,
    CheckoutStatus.VERIFYING_IDV_RESULT,
  ],
  awaitStatus: CheckoutStatus.AWAIT_IDV_COMPLETION,
  verifyingResultStatus: CheckoutStatus.VERIFYING_IDV_RESULT,
  verifyEndpoint: "verify-kyc",
  storageKey: "kyc_redirect_initiated",
  sessionStorageKeyPrefix: "cosmos_kyc_redirect",
  logTag: "kyc",
  telemetry: {
    redirectToUi: "KYC_REDIRECT_TO_UI",
    returnFromUi: "KYC_RETURN_FROM_UI",
    verifySuccess: "KYC_VERIFY_SUCCESS",
    verifyFailed: "KYC_VERIFY_FAILED",
  },
  redirectIcon: "shield",
};

/** @deprecated Use IDV_VERIFICATION_CONFIG */
export const KYC_VERIFICATION_CONFIG = IDV_VERIFICATION_CONFIG;
